import { parseString } from './helpers'

export interface CustomerInterface {
  id: string
  name: string
  code: string
  address: string
}

export interface CustomerResponseInterface {
  id: string
  name: string
  code: string
  address: string
}

export function parseCustomerModel(response: CustomerResponseInterface): CustomerInterface {
  return {
    id: parseString(response?.id),
    name: parseString(response?.name),
    code: parseString(response?.code),
    address: parseString(response?.address),
  }
}
